import { ImageGroupDto } from "./ImageGroupDto";
var ProductVariantDto = (function () {
    function ProductVariantDto(link, orderable, price, promoPrice, id, color, color_name, imageGroups, size, size_name, badge, backInStockNotificationEnabled, isProductExclusive, selected, longDescription, shortDescription, backInStockNotificationUntil, backInStockNotificationStart, notifyMeMessage, enableShadeFinder, listPrice, isNotifyMe, isAvailable, swatchImageUrl, primaryImageUrl) {
        if (link === void 0) { link = ""; }
        if (orderable === void 0) { orderable = false; }
        if (price === void 0) { price = 0; }
        if (promoPrice === void 0) { promoPrice = 0; }
        if (id === void 0) { id = ""; }
        if (color === void 0) { color = ""; }
        if (color_name === void 0) { color_name = ""; }
        if (imageGroups === void 0) { imageGroups = []; }
        if (enableShadeFinder === void 0) { enableShadeFinder = false; }
        this.link = link;
        this.orderable = orderable;
        this.price = price;
        this.promoPrice = promoPrice;
        this.id = id;
        this.color = color;
        this.color_name = color_name;
        this.imageGroups = imageGroups;
        this.size = size;
        this.size_name = size_name;
        this.badge = badge;
        this.backInStockNotificationEnabled = backInStockNotificationEnabled;
        this.isProductExclusive = isProductExclusive;
        this.selected = selected;
        this.longDescription = longDescription;
        this.shortDescription = shortDescription;
        this.backInStockNotificationUntil = backInStockNotificationUntil;
        this.backInStockNotificationStart = backInStockNotificationStart;
        this.notifyMeMessage = notifyMeMessage;
        this.enableShadeFinder = enableShadeFinder;
        this.listPrice = listPrice;
        this.isNotifyMe = isNotifyMe;
        this.isAvailable = isAvailable;
        this.swatchImageUrl = swatchImageUrl;
        this.primaryImageUrl = primaryImageUrl;
    }
    ProductVariantDto.getVariantPromoPrice = function (ocapiVariation, ocapiProduct) {
        var _a, _b;
        var variationAttributes = (_a = ocapiProduct.c_variantCustomAttributes) === null || _a === void 0 ? void 0 : _a[ocapiVariation.product_id];
        return (_b = variationAttributes === null || variationAttributes === void 0 ? void 0 : variationAttributes.promoPrice) !== null && _b !== void 0 ? _b : ocapiVariation.c_promoPrice;
    };
    ProductVariantDto.getIsNotifyMe = function (ocapiProduct, ocapiVariation) {
        var _a, _b;
        var variantId = ocapiVariation.product_id;
        var productNotifyMeStatus = (_a = ocapiProduct.c_productsNotifyMeStatus) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.productId === variantId; });
        return (_b = productNotifyMeStatus === null || productNotifyMeStatus === void 0 ? void 0 : productNotifyMeStatus.isNotifyMe) !== null && _b !== void 0 ? _b : false;
    };
    ProductVariantDto.getIsAvailable = function (ocapiProduct, ocapiVariation) {
        var _a, _b;
        var variantId = ocapiVariation.product_id;
        var productNotifyMeStatus = (_a = ocapiProduct.c_productsNotifyMeStatus) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.productId === variantId; });
        return (_b = productNotifyMeStatus === null || productNotifyMeStatus === void 0 ? void 0 : productNotifyMeStatus.isAvailable) !== null && _b !== void 0 ? _b : false;
    };
    ProductVariantDto.fromOcapi = function (ocapiVariation, ocapiProduct) {
        var _a, _b, _c, _d, _e;
        var color = (_b = (_a = ocapiVariation.variation_values) === null || _a === void 0 ? void 0 : _a.color) !== null && _b !== void 0 ? _b : "";
        var colorName = this.getVariationAttributeName(color, 'color', ocapiProduct);
        var size = (_d = (_c = ocapiVariation.variation_values) === null || _c === void 0 ? void 0 : _c.size) !== null && _d !== void 0 ? _d : "";
        var sizeName = this.getVariationAttributeName(size, 'size', ocapiProduct);
        var imageGroups = this.getVariationAttributeImageGroups(size || color, ocapiProduct);
        var isNotifyMe = this.getIsNotifyMe(ocapiProduct, ocapiVariation);
        var isAvailable = this.getIsAvailable(ocapiProduct, ocapiVariation);
        var variantCustomAttributes = this.getVariationCustomAttributes(ocapiVariation.product_id, ocapiProduct);
        return new ProductVariantDto(((_e = variantCustomAttributes.productUrl) === null || _e === void 0 ? void 0 : _e.length) > 0 ? variantCustomAttributes.productUrl : ocapiVariation.link, ocapiVariation.orderable, ocapiVariation.price, this.getVariantPromoPrice(ocapiVariation, ocapiProduct), ocapiVariation.product_id, color, colorName, imageGroups, size, sizeName, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, isNotifyMe, isAvailable, undefined, undefined);
    };
    ProductVariantDto.getMatchingVariantAttribute = function (attrName, variationAttributes) {
        return variationAttributes.find(function (attr) {
            return attr.id === attrName;
        });
    };
    ProductVariantDto.getMatchingVariantName = function (attrName, variationValues) {
        return variationValues ? variationValues.find(function (attr) {
            return attr.value === attrName;
        }) : undefined;
    };
    ProductVariantDto.getVariationAttributeName = function (attrValue, attrName, ocapiProduct) {
        var _a, _b, _c;
        if (!attrName || !((_a = ocapiProduct.variation_attributes) === null || _a === void 0 ? void 0 : _a.length))
            return "";
        var values = (_b = ProductVariantDto.getMatchingVariantAttribute(attrName, ocapiProduct.variation_attributes)) === null || _b === void 0 ? void 0 : _b.values;
        return ((_c = ProductVariantDto.getMatchingVariantName(attrValue, values)) === null || _c === void 0 ? void 0 : _c.name) || "";
    };
    ProductVariantDto.getVariationAttributeImageGroups = function (attrName, ocapiProduct) {
        var _a;
        var imageGroups = (_a = ocapiProduct.image_groups) !== null && _a !== void 0 ? _a : ocapiProduct.imageGroups;
        return !!attrName && (imageGroups === null || imageGroups === void 0 ? void 0 : imageGroups.length) ?
            imageGroups.filter(function (g) {
                var _a, _b, _c, _d;
                var variationAttributes = (_a = g.variation_attributes) !== null && _a !== void 0 ? _a : g.variationAttributes;
                return ((_d = (_c = (_b = variationAttributes === null || variationAttributes === void 0 ? void 0 : variationAttributes[0]) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c[0]) === null || _d === void 0 ? void 0 : _d.value) === attrName;
            }).map(function (g) {
                return ImageGroupDto.fromOcapi(g);
            }) : [];
    };
    ProductVariantDto.getVariationCustomAttributes = function (pid, ocapiProduct) {
        var _a, _b;
        var varAttr = (_b = (_a = ocapiProduct.c_variantCustomAttributes) === null || _a === void 0 ? void 0 : _a[pid]) !== null && _b !== void 0 ? _b : {};
        return varAttr;
    };
    return ProductVariantDto;
}());
export { ProductVariantDto };
//# sourceMappingURL=ProductVariantDto.js.map